import { UPDATE_DELEGATE_CONFIGURATION, GET_DELEGATE_CONFIGURATION_DETAILS } from "../../../utils/constants";

const initialState = [];

function delegateConfigurationReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case UPDATE_DELEGATE_CONFIGURATION:
            return [...state, payload];
        case GET_DELEGATE_CONFIGURATION_DETAILS:
            return [...state, payload];

        default:
            return state;
    }
};

export default delegateConfigurationReducer